import type { UseControllerReturn } from "react-hook-form";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";

interface UseValidationIconParams {
  controller: UseControllerReturn;
  disabled?: boolean;
}

export const useValidationIcon = ({
  controller,
  disabled = false,
}: UseValidationIconParams): React.ReactNode => {
  const {
    fieldState: { invalid, isDirty, isTouched },
  } = controller;

  if (disabled || !isDirty || !isTouched) {
    return null;
  }

  return invalid ? (
    <CancelOutlinedIcon
      color="error"
      sx={(theme) => ({ color: theme.palette.error.main })}
    />
  ) : (
    <CheckCircleOutlineOutlinedIcon
      color="success"
      sx={(theme) => ({ color: theme.palette.success.main })}
    />
  );
};
